import { IQuoteRequest } from 'features/BookingFlow'

import {
  MQBuyersConsolidationDefaultValuesBehaviour,
  MQBuyersConsolidationFormFieldsBehaviour,
  MQBuyersConsolidationFormSchemaBehaviour,
  MQBuyersConsolidationServicesBehaviour,
  MQBuyersConsolidationSummaryBehaviour,
} from './MQBuyersConsolidationBehaviour'
import {
  MQCusomQuoteFormSchemaBehaviour,
  MQCustomQuoteDefaultValuesBehaviour,
  MQCustomQuoteFormFieldsBehaviour,
  MQCustomQuoteHeaderBehaviour,
  MQCustomQuoteSummaryBehaviour,
} from './MQCustomQuoteBehaviour'
import {
  MQDangerousGoodsFormFieldsBehaviour,
  MQDangerousGoodsFormSchemaBehaviour,
  MQDangerousGoodsHeaderBehaviour,
  MQDangerousGoodsServicesBehaviour,
  MQDangerousGoodsSummaryBehaviour,
} from './MQDangerousGoodsBehaviour'
import { MQFormContentProcessor } from './MQFormContentProcessor'
import { ManualQuoteType } from './useManualQuoteDialogState'

type GetManualQuoteFormContentArgs = {
  quoteRequest: IQuoteRequest
  mqDialogType: ManualQuoteType
  salesManagerEmail?: string
}
export const getManualQuoteFormContent = ({
  quoteRequest,
  mqDialogType,
  salesManagerEmail,
}: GetManualQuoteFormContentArgs) => {
  const formContent = new MQFormContentProcessor({
    headerBehaviour: new MQCustomQuoteHeaderBehaviour(),
    summaryBehaviour: [new MQCustomQuoteSummaryBehaviour()],
    formSchemaBehaviour: [new MQCusomQuoteFormSchemaBehaviour()],
    formFieldsBehaviour: new MQCustomQuoteFormFieldsBehaviour(),
    servicesBehaviour: [],
    defaultValuesBehaviour: [new MQCustomQuoteDefaultValuesBehaviour(quoteRequest)],
  })

  if (mqDialogType === 'DANGEROUS_GOODS') {
    formContent.setHeaderBehaviour(new MQDangerousGoodsHeaderBehaviour())
    formContent.setSummaryBehaviour(
      new MQDangerousGoodsSummaryBehaviour(salesManagerEmail ?? 'dangerousgoods@forto.com')
    )
    formContent.addFormSchemaBehaviour(new MQDangerousGoodsFormSchemaBehaviour())
    formContent.addServiceBehaviour(new MQDangerousGoodsServicesBehaviour())
    formContent.setFormFieldsBehaviour(new MQDangerousGoodsFormFieldsBehaviour())
  }

  if (quoteRequest.buyersConsolidation) {
    formContent.setSummaryBehaviour(new MQBuyersConsolidationSummaryBehaviour())
    formContent.setFormFieldsBehaviour(new MQBuyersConsolidationFormFieldsBehaviour())
    formContent.addServiceBehaviour(new MQBuyersConsolidationServicesBehaviour())
    formContent.addFormSchemaBehaviour(new MQBuyersConsolidationFormSchemaBehaviour())
    formContent.addDefaultValuesBehaviour(new MQBuyersConsolidationDefaultValuesBehaviour(quoteRequest))
  }

  return formContent
}
